import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getUserListUrl, GET_USER_LIST_ACTION, userDetailsUrl, GET_USER_DETAILS_ACTION, headers, shareCredentialUrl, SHARE_CREDENTIAL_ACTION, fetchAuthReport, GET_USER_REGISTRATION_RPT_ACTION_TYPE, registrationReportName, updateMemberDetailsUrl, UPDATE_MEMBER_DETAILS_ACTION, getUserListExportUrl, GET_USER_LIST_EXPORT_ACTION } from "../../utils/constants"

export const get_userList_action = (MembershipNo, CompanyName, EmailAddress, IsActive) => async (dispatch) => {
    try {
        const mapdata = {
            userId: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserId ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserId : null,
            MembershipNo: MembershipNo != null ? MembershipNo : null,
            CompanyName: CompanyName != null ? CompanyName : null,
            EmailAddress: EmailAddress != null ? EmailAddress : null,
            IsActive: IsActive == 0 ? 0 : 1
        }
        const res = await axiosGet(getUserListUrl, mapdata, headers);

        dispatch({
            type: GET_USER_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const get_userList_export_action = () => async (dispatch) => {
    try {
        const mapdata = {
            userId: sessionStorage.getItem('UserIDSS') != '' && sessionStorage.getItem('UserIDSS') != null ? sessionStorage.getItem('UserIDSS') : null,
        }
        const res = await axiosGet(getUserListExportUrl, mapdata, headers);

        dispatch({
            type: GET_USER_LIST_EXPORT_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const get_userDetails_action = (MemberId) => async (dispatch) => {
    try {
        const mapdata = {
            userId: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserId ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserId : null,
            MemberId: MemberId
        }
        const res = await axiosGet(userDetailsUrl, mapdata, headers);
        dispatch({
            type: GET_USER_DETAILS_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const share_credential_action = (MemberID) => async (dispatch) => {
    try {
        const mapdata = {
            MemberID: MemberID
        }

        const res = await axiosPost(shareCredentialUrl, mapdata, headers);
        console.log("share_credential_action res", res)

        dispatch({
            type: SHARE_CREDENTIAL_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const userRegistrationRpt_action = (MemberID) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            "ParameterName": "@MemberID",
            "ParameterValue": MemberID,
            "ParameterDataType": "int"
        }
        list.push(mapdata1);
        const mapData = {
            "report_name": registrationReportName,
            "parameter_details": list
        }
        const res = await axiosPost(fetchAuthReport, mapData, headers);
        dispatch({
            type: GET_USER_REGISTRATION_RPT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const updateMemberDetails_action = (MemberID, MembershipNo, CompanyName, CompanyWebsite, IndustryID, EstablishmentYear, Address1, Address2, City, State, CountryID, Title, ContactPersonName, ContactPersonDesignation, EmailAddress, PhoneNumber, SameAsCorrespondance, INVCompanyName, INVCompanyWebsite, INVIndustryID, INVEstablishmentYear, INVAddress1, INVAddress2, INVCity, INVState, INVCountryID, INVTitle, INVContactPersonName, INVContactPersonDesignation, INVEmailAddress, INVPhoneNumber, GSTNo, PANNo, buisnessSectorList, exportMarketsList, primaryServicesList, annualRevenue, documentsList, OtherBusinessSector, OtherPrimaryServices, primaryProduct) => async (dispatch) => {
    try {
        const mapdata = {
            MemberID: MemberID,
            MembershipNo: MembershipNo,
            CompanyName: CompanyName,
            CompanyWebsite: CompanyWebsite,
            IndustryID: 1,
            EstablishmentYear: EstablishmentYear,
            Address1: Address1,
            Address2: Address2,
            City: City,
            State: State,
            CountryID: CountryID,
            Title: Title,
            ContactPersonName: ContactPersonName,
            ContactPersonDesignation: ContactPersonDesignation,
            EmailAddress: EmailAddress,
            PhoneNumber: PhoneNumber,
            SameAsCorrespondance: SameAsCorrespondance,

            INVCompanyName: INVCompanyName,
            INVCompanyWebsite: INVCompanyWebsite,
            INVIndustryID: 1,
            INVEstablishmentYear: INVEstablishmentYear,
            INVAddress1: INVAddress1,
            INVAddress2: INVAddress2,
            INVCity: INVCity,
            INVState: INVState,
            INVCountryID: INVCountryID,
            INVTitle: INVTitle,
            INVContactPersonName: INVContactPersonName,
            INVContactPersonDesignation: INVContactPersonDesignation,
            INVEmailAddress: INVEmailAddress,
            INVPhoneNumber: INVPhoneNumber,

            GSTNo: GSTNo,
            PANNo: PANNo,
            buisnessSectorList: buisnessSectorList,
            exportMarketsList: exportMarketsList,
            primaryServicesList: primaryServicesList,
            AnnualRevenue: annualRevenue,
            documentsList: documentsList,
            OtherBusinessSector: OtherBusinessSector,
            OtherPrimaryServices: OtherPrimaryServices,
            PrimaryServices: primaryProduct,
        }
        // console.log("registrationFormAddUrl", registrationFormAddUrl)
        console.log("mapdata", mapdata)

        const res = await axiosPost(updateMemberDetailsUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: UPDATE_MEMBER_DETAILS_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
